import { DollarSign, Zap, X } from 'lucide-react'

/**
 * Cost confirmation dialog shown before any generation job
 */
export default function CostConfirmDialog({ jobLabel, estimatedCost, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-surface-card border border-surface-border rounded-2xl p-6 shadow-2xl w-80">

        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-white font-semibold text-base">Confirm Generation</h3>
          <button onClick={onCancel} className="text-slate-500 hover:text-slate-300 transition-colors">
            <X size={16} />
          </button>
        </div>

        {/* Job info */}
        <div className="bg-surface rounded-xl p-4 mb-4 border border-surface-border">
          <div className="text-sm text-slate-300 font-medium mb-3">{jobLabel}</div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-green-500/15 flex items-center justify-center">
                <DollarSign size={14} className="text-green-400" />
              </div>
              <div>
                <div className="text-xs text-slate-500">Estimated cost</div>
                <div className="text-lg font-bold text-green-400">{estimatedCost}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="text-xs text-slate-500">GPU</div>
              <div className="text-xs font-medium text-slate-300">A40 · 48GB</div>
            </div>
          </div>
        </div>

        <p className="text-xs text-slate-500 mb-5 leading-relaxed">
          This will submit a job to your RunPod endpoint. Billed per second of actual compute used.
        </p>

        {/* Actions */}
        <div className="flex gap-3">
          <button onClick={onCancel} className="btn-secondary flex-1 justify-center">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn-primary flex-1 justify-center">
            <Zap size={14} /> Generate
          </button>
        </div>

      </div>
    </div>
  )
}
